import BaseCard from 'components/Cards/BaseCard';
import SettingButton from '../../../../components/SettingButton';
import { CARD_CLASS_NAMES, IMAGING_MODES } from '../../../../config/floodDeviceConfig';

export default function ImagingModesCard({ deviceSettings, setDeviceSettings, device, enabled }) {
  return (
    <BaseCard
      className={`shadow-sm ${CARD_CLASS_NAMES.card}`}
      header="Imaging Modes"
      headerClassName={CARD_CLASS_NAMES.cardHeader}
      bodyClassName={`d-flex flex-column gap-2 ${CARD_CLASS_NAMES.cardBody}`}
    >
      {IMAGING_MODES.map(({ displayName, settingName }) => (
        <SettingButton
          key={settingName}
          displayName={displayName}
          settingName={settingName}
          deviceSettings={deviceSettings}
          setDeviceSettings={setDeviceSettings}
          device={device}
          enabled={enabled}
        />
      ))}
    </BaseCard>
  );
}
